import React from "react";
import Modal from "@mui/material/Modal";
import TextView from "../TextView";
import Button from "../Button";
import { colors } from "../../utils";
import styled from "styled-components";

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 45%;
  right: 0;
  left: 0;
  z-index: 100;
`;

const Container = styled.div`
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 400px;
  width: 50vw;
  min-width: 550px;
  background-color: ${colors.white};
  border-radius: 10px;
  padding: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0px 0px 9.6px 0px #00000026;
`;

const ButtonView = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 20px;
`;

const Icon = styled.img`
  width: 50px;
  height: 50px;
  margin-bottom: 20px;
`;

export default function DialogModal({
  open,
  onClose,
  title,
  message,
  extraText,
  icon,
  primaryButton,
  secondaryButton,
  onPrimaryPress,
  onSecondaryPress,
  allowClose = true,
  isModal = true,
  isPhoneInput = false,
  modalStyle,
}) {
  const ModalWrapper = !isModal ? Wrapper : Modal;

  return (
    <ModalWrapper hideBackdrop={!allowClose} open={open} onClose={onClose}>
      <Container style={modalStyle}>
        {icon ? <Icon src={icon} /> : null}
        <TextView
          variant="title"
          style={{ textAlign: "center", marginBottom: 20 }}
        >
          {title}
        </TextView>
        <TextView variant="subtitle" style={{ textAlign: "center" }}>
          {message}
        </TextView>

        {!!extraText && !isPhoneInput ? (
          <TextView style={{ textAlign: "center", marginTop: 10 }}>
            {extraText}
          </TextView>
        )
        : (
          extraText
        )
        }
        <ButtonView>
          {secondaryButton && (
            <Button
              variant={"secondary"}
              onClick={onSecondaryPress}
              style={{
                width: 120,
                marginRight: 20,
              }}
            >
              {secondaryButton}
            </Button>
          )}
          {primaryButton && (
            <Button
              onClick={onPrimaryPress}
              style={{
                width: 140,
              }}
            >
              {primaryButton}
            </Button>
          )}
        </ButtonView>
      </Container>
    </ModalWrapper>
  );
}
